import HouseWater from '@/assets/house-water.svg?react';

import ManChatMoney from '@/assets/man-chat-money.svg?react';
import ArrowRight from '@/assets/right-arrow.svg?react';
import SearchForDocs from '@/assets/search-for-docs.svg?react';
import StockBearish from '@/assets/stock-bearish.svg?react';
import StockBullish from '@/assets/stock-bullish.svg?react';
import Truck from '@/assets/truck.svg?react';
import UmbrellaCard from '@/assets/umbrella-card.svg?react';
import AfterDoc from '@/components/ui/AfterDoc';
import { AnchoredPanel } from '@/features/v2/components/panel';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const interestAreas = [
  {
    StartElement: HouseWater,
    href: 'https://l.helpfind.pl/nieruchomosci/?utm_source=ss-blachy-drzewko',
    content: 'Szkoda na nieruchomości',
    EndElement: ArrowRight,
  },
  {
    StartElement: UmbrellaCard,
    href: 'https://l.helpfind.pl/sankcja-kredytu/?utm_source=ss-blachy-drzewko',
    content: 'Sankcja kredytu darmowego',
    EndElement: ArrowRight,
  },
  {
    StartElement: ManChatMoney,
    href: 'https://z.helpfind.pl/parabanki/?utm_source=ss-blachy-drzewko',
    content: 'Pożyczki pozabankowe',
    EndElement: ArrowRight,
  },
  {
    StartElement: StockBearish,
    href: 'https://z.helpfind.pl/polisolokaty/?utm_source=ss-blachy-drzewko',
    content: 'Zwrot z polisolokaty',
    EndElement: ArrowRight,
  },
  {
    StartElement: SearchForDocs,
    href: 'https://z.helpfind.pl/frankowicze/?utm_source=ss-blachy-drzewko',
    content: 'Unieważnij kredyt CHF',
    EndElement: ArrowRight,
  },
  {
    StartElement: Truck,
    href: 'https://z.helpfind.pl/kartel-producentow-ciezarowek/?utm_source=ss-blachy-drzewko',
    content: 'Zwrot za zakup ciężarówki',
    EndElement: ArrowRight,
  },
  {
    StartElement: StockBullish,
    href: 'https://l.helpfind.pl/wyzsza-emerytura/?utm_source=ss-blachy-drzewko',
    content: 'Prawo do wyższej emerytury',
    EndElement: ArrowRight,
  },
];

const ThankYouAll = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      title={i18n.t('Dziękujemy za odpowiedzi!')}
      thankYouMessage={i18n.t(
        'Przygotowanie propozycji zajmie nam maksymalnie 3 dni robocze'
      )}
    >
      <div className="body flex flex-col gap-2 lg:text-base">
        <span>
          {i18n.t(
            'Dzięki podanym odpowiedziom nasz rzeczoznawca ma więcej informacji, które pomogą precyzyjniej określić kwotę odkupu szkody.'
          )}
        </span>

        <span>{i18n.t('Rzeczoznawca sprawdzi, czy w Twoim kosztorysie:')}</span>
        <ul className="list-disc space-y-1 pl-3.5 pt-1 lg:pl-6">
          <li>{i18n.t('zastosowano prawidłową stawkę fachowców')}</li>
          <li>{i18n.t('uwzględniono koszty części oryginalnych')}</li>
          <li>{i18n.t('wyceniona została prawidłowa technologia naprawy')}</li>
          <li>{i18n.t('dokonano nieuzasadnionych odliczeń i rabatów')}</li>
        </ul>
      </div>

      <section className="mt-4 lg:mt-5 lg:space-y-5">
        <h4 className="h4 mb-4">
          {i18n.t('Inne obszary, w których możemy Ci pomóc:')}
        </h4>
        <div className="max-w-80 space-y-4">
          {interestAreas.map(
            ({ content, StartElement, EndElement, href }, index) => (
              <AnchoredPanel
                key={index}
                href={href}
                startElement={<StartElement className="size-6" />}
                endElement={
                  <EndElement className="size-4.5 transition duration-150 ease-in-out group-hover:translate-x-0.5" />
                }
                className="transition duration-150 ease-in-out group-hover:text-primary"
              >
                {content}
              </AnchoredPanel>
            )
          )}
        </div>
      </section>
    </AfterDoc>
  );
};

export default ThankYouAll;
